import { search } from "@nosto/search-js"
import type { SearchQuery } from "@nosto/nosto-js/client"
import type { DecoratedResult } from "@nosto/search-js"
import type { Product } from "@/types"
import { hitDecorators, styleFamilyCatalogChunkSize } from "@/config"

const catalogProductFields = [
  "productId",
  "url",
  "name",
  "imageUrl",
  "imageHash",
  "thumbUrl",
  "description",
  "brand",
  "variantId",
  "availability",
  "price",
  "priceText",
  "categoryIds",
  "categories",
  "customFields.key",
  "customFields.value",
  "priceCurrencyCode",
  "datePublished",
  "listPrice",
  "unitPricingBaseMeasure",
  "unitPricingUnit",
  "unitPricingMeasure",
  "googleCategory",
  "gtin",
  "ageGroup",
  "gender",
  "condition",
  "alternateImageUrls",
  "ratingValue",
  "reviewCount",
  "inventoryLevel",
  "skus.id",
  "skus.name",
  "skus.price",
  "skus.listPrice",
  "skus.priceText",
  "skus.url",
  "skus.imageUrl",
  "skus.inventoryLevel",
  "skus.customFields.key",
  "skus.customFields.value",
  "skus.availability",
  "pid",
  "onDiscount",
  "extra.key",
  "extra.value",
  "saleable",
  "available",
  "tags1",
  "tags2",
  "tags3"
]

/**
 * Fetches every raw Nosto hit for the current query by repeatedly paging with
 * `from` / `size`, then returns the decorated hits in order.
 */
export async function fetchAllSearchHits(baseQuery: SearchQuery, total: number): Promise<Product[]> {
  const all: Product[] = []
  let from = 0

  while (from < total) {
    const size = Math.min(styleFamilyCatalogChunkSize, total - from)
    const productsQuery = {
      ...baseQuery.products,
      fields: baseQuery.products?.fields ?? catalogProductFields,
      from,
      size
    }
    const result: DecoratedResult<typeof hitDecorators> = await search(
      {
        ...baseQuery,
        products: productsQuery
      },
      { hitDecorators: [...hitDecorators] }
    )

    const batch = result.products.hits as Product[]
    if (batch.length === 0) {
      break
    }

    all.push(...batch)
    from += batch.length
  }

  return all
}
